module.exports = __webpack_public_path__ + "img/chargingpoint-fastcharger-planned.d7690cfd.png";